import { observer } from 'mobx-react';
import React from 'react';
import { useStore } from '../../../app/data/root.store';
import { VaultFilters } from '../VaultFilters/VaultFilters';
import { VaultInitialEmptyState } from '../VaultInitialEmptyState/VaultInitialEmptyState';
import { VaultMobileFiltersWrapper, VaultMobileHeaderActions, VaultMobileHeaderContainer, VaultMobileHeaderTitle } from './VaultMobileList.styles';

export const VaultMobileHeader = observer(() => {
    const { vaultStore } = useStore();
    const isEmptyState = !vaultStore.isLoading && vaultStore.files.length === 0 && !vaultStore.hasActiveFilters;
    return (
        <VaultMobileHeaderContainer>
            {isEmptyState ? (
                <VaultInitialEmptyState />
            ) : (
                <VaultMobileHeaderTitle>
                    Store, organize and analyze your financial documents
                </VaultMobileHeaderTitle>
            )}
            <VaultMobileHeaderActions>
                <VaultMobileFiltersWrapper>
                    <VaultFilters disabled={isEmptyState} />
                </VaultMobileFiltersWrapper>
            </VaultMobileHeaderActions>
        </VaultMobileHeaderContainer>
    );
}); 